"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggler = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Svg = require("../../../Svg");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var switcher = function switcher(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "#E6E6E6"
  }));
};
switcher.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Toggler = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
    as: switcher
  }));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  border: ", ";\n  background-color: ", ";\n  height: 28px;\n  width: 52px;\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  border-radius: 52px;\n  justify-content: ", ";\n  & svg rect {\n    fill: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid ".concat(theme.colors.secondaryShade2);
}, function (_ref3) {
  var theme = _ref3.theme,
    checked = _ref3.checked;
  return checked ? theme.colors.primary : theme.colors.secondaryShade;
}, function (_ref4) {
  var checked = _ref4.checked;
  return checked ? 'flex-end' : 'flex-start';
}, function (_ref5) {
  var theme = _ref5.theme,
    checked = _ref5.checked;
  return checked && theme.colors.secondary;
});
exports.Toggler = Toggler;